/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import ReactToPrint from "react-to-print";
import ControlledDialog from "../../../components/ControlledDialog/ControlledDialog";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import "./Chunks/PrintCss.css";
import {
  IsEmpty,
  getCachedBlobFile,
  setCacheBlobFile,
  formatBytes,
  formatInternetEstTime,
} from "../../../utils/helper";
import axios, { isCancel, CancelToken } from "axios";

const SummaryPdfView = (props) => {
  const { handleClose, open } = props;
  const componentRef = useRef();
  const [onErrorAttemptCount, setErrorAttemptCount] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [summaryPDFFile, setSummaryPDFFile] = useState(props.summaryPdfFile);
  const [loadingPdf, setLoadingPdf] = useState(true);
  const [renderingPdf, setRenderingPdf] = useState(true);

  const [progress, setProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const [downloadedContent, setDownloadedContent] = useState(0);
  const [totalContent, setTotalContent] = useState(0);
  const [speed, setSpeed] = useState(0);
  const [estimatedTime, setEstimatedTime] = useState(0);

  const lastTimeRef = useRef(new Date().getTime());
  const lastLoadedRef = useRef(0);
  const lastSpeedRef = useRef(0);

  function onDocumentError() {
    const count = onErrorAttemptCount + 1;
    setRenderingPdf(false);
    setLoadingPdf(false);
    setErrorAttemptCount(count);
    if (count <= 1) {
      downloadDataFromServerForPrint();
    }
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setErrorAttemptCount(0);
  }

  function onPageRenderSuccess(index) {
    const pageNumber = (index || 0) + 1;
    if (numPages == pageNumber) {
      setRenderingPdf(false);
      console.log("Completely Render");
    }
  }
  function onPageLoadedSuccess(index) {
    const pageNumber = (index || 0) + 1;
    if (numPages == pageNumber) {
      setLoadingPdf(false);
      console.log("Completely Render");
    }
  }

  useEffect(() => {
    // if (props.summaryPdfFile != "") {
    console.log("pdf use effect");
    setAndGetData();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values.summaryPDFUseEffectCall]);

  const setAndGetData = async () => {
    if (
      props.values.selectedOrder.orderId &&
      props.values.selectedSalesData.productId &&
      props.values.selectedOrder.jobId
    ) {
      const fileName = `${props.values.selectedOrder.orderId}-${props.values.selectedSalesData.id}-${props.values.selectedSalesData.categoryUserLabel}.pdf`;
      const getStoredFile = await getCachedBlobFile(fileName);
      if (!IsEmpty(getStoredFile) && getStoredFile.code == 1) {
        let csvURL = URL.createObjectURL(getStoredFile.blob);
        setSummaryPDFFile(csvURL);
      } else {
        // const imageUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${props.summaryPdfFile}`;
        // setSummaryPDFFile(imageUrl);
        downloadDataFromServerForPrint();
      }
    }
  };

  const downloadDataFromServerForPrint = async () => {
    const source = CancelToken.source();
    setCancelTokenSource(source);
    setIsDownloading(true);
    setProgress(0);
    setDownloadedContent(0);
    setTotalContent(0);
    setSpeed(0);
    setEstimatedTime(0);
    lastLoadedRef.current = 0;
    lastTimeRef.current = new Date().getTime();

    try {
      const ckObject = localStorage.getItem("ckAdminUser") || "{}";
      const data = JSON.parse(ckObject) || {};
      const { jwttoken = "" } = data;
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsImagesSummaryDownload?orderId=${props.values.selectedOrder.orderId}&productId=${props.values.selectedSalesData.productId}&orderItemId=${props.values.selectedOrder.jobId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${jwttoken}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
          setDownloadedContent(progressEvent.loaded);
          setTotalContent(progressEvent.total);

          // Calculate speed
          const currentTime = new Date().getTime();
          const elapsedTime = (currentTime - lastTimeRef.current) / 1000; // seconds

          if (elapsedTime > 0.5) {
            // Min interval to reduce fluctuations
            const bytesDownloadedInInterval =
              progressEvent.loaded - lastLoadedRef.current;
            const currentSpeed = bytesDownloadedInInterval / elapsedTime;

            // Apply smoothing to reduce speed fluctuations
            const smoothedSpeed = lastSpeedRef.current
              ? lastSpeedRef.current * 0.8 + currentSpeed * 0.2
              : currentSpeed;

            setSpeed(smoothedSpeed);
            lastSpeedRef.current = smoothedSpeed;

            // Estimate remaining time
            const remainingBytes = progressEvent.total - progressEvent.loaded;
            const estimatedTime =
              smoothedSpeed > 0 ? remainingBytes / smoothedSpeed : 0;
            setEstimatedTime(estimatedTime);

            lastTimeRef.current = currentTime;
            lastLoadedRef.current = progressEvent.loaded;
          }
        },
      });

      const fileName = `${props.values.selectedOrder.orderId}-${props.values.selectedSalesData.id}-${props.values.selectedSalesData.categoryUserLabel}.pdf`;

      // Create a blob link to download
      const blob = new Blob([response.data]);
      await setCacheBlobFile(blob, fileName);
      let csvURL = URL.createObjectURL(blob);
      setSummaryPDFFile(csvURL);
    } catch (error) {
      if (isCancel(error)) {
        console.log("Download canceled");
      } else if (error.response) {
        if (error.response.status === 401) {
          console.error("Unauthorized access - Please check your credentials.");
        } else {
          console.error("Download failed:", error.response.data);
        }
      } else {
        console.error("Download failed:", error);
      }
    } finally {
      setIsDownloading(false);
      setProgress(0);
      setCancelTokenSource(null);
      setDownloadedContent(0);
      setTotalContent(0);
      setSpeed(0);
      setEstimatedTime(0);
    }
  };

  const cancelDownload = () => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
      setIsDownloading(false);
      setProgress(0);
      setDownloadedContent(0);
      setTotalContent(0);
      setSpeed(0);
      setEstimatedTime(0);
    }
  };

  return (
    <Fragment>
      <ControlledDialog
        isFullScreen={true}
        open={open}
        fullWidth
        disableBackdropClick
        handleClose={() => {
          cancelDownload();
          // setLoadingPdf(true);
          setSummaryPDFFile("");
          setRenderingPdf(true);
          setErrorAttemptCount(0);
          handleClose();
        }}
        title={
          <Fragment>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >
              Summary Print Dialog
            </span>
          </Fragment>
        }
        content={
          <Fragment>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button
                    id="btnShippingLabelPrint"
                    disabled={
                      isDownloading ||
                      loadingPdf ||
                      renderingPdf ||
                      onErrorAttemptCount > 1
                    }
                    style={{
                      marginTop: 2,
                      //marginRight: 10,
                      textTransform: "capitalize",
                      opacity: 0.8,
                      float: "right",
                      zIndex: 1000,
                    }}
                    color="primary"
                    variant="contained"
                  >
                    Print
                  </Button>
                );
              }}
              content={() => componentRef.current}
              pageStyle="@page { size: A4 landscape; margin: 0; overflow: hidden; } 
                body { margin: 0; padding: 0; overflow: hidden; } 
                div { margin: 0; padding: 0; overflow: hidden; }"
            />
            {(loadingPdf || renderingPdf) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    marginRight: 20,
                  }}
                >
                  {isDownloading
                    ? "Summary getting from server..."
                    : renderingPdf
                    ? "Summary rendering in our page..."
                    : "Loading Summary"}
                </div>
                <CircularProgress size={22} />
              </div>
            )}

            {onErrorAttemptCount > 1 && (
              <div>
                Getting error to load file, Session expired or file error Please
                retry by re-login.
              </div>
            )}

            {/* Actual PDF Content */}

            <div
              className="print-only"
              style={{ overflow: "hidden" }}
              ref={componentRef}
            >
              <Document
                file={summaryPDFFile}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    scale={2}
                    pageNumber={index + 1}
                    onRenderSuccess={() => onPageRenderSuccess(index)}
                    onLoadSuccess={() => onPageLoadedSuccess(index)}
                  />
                ))}
              </Document>
            </div>

            {/* Just For Display */}

            <div className="no-print">
              {isDownloading && (
                <>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontSize: 14,
                        marginTop: 10,
                      }}
                    >
                      Downloading: <b style={{ marginLeft: 10 }}>{progress}%</b>
                    </div>
                    <progress
                      style={{ width: "100%" }}
                      value={progress}
                      max="100"
                    />
                    <div style={{ textAlign: "center", fontSize: 12 }}>
                      {`${formatBytes(downloadedContent)} / ${formatBytes(
                        totalContent
                      )}`}
                    </div>
                    <div style={{ textAlign: "center", fontSize: 12 }}>
                      Speed: {formatBytes(speed)}/s
                    </div>
                    <div style={{ textAlign: "center", fontSize: 12 }}>
                      Est: {formatInternetEstTime(estimatedTime)}
                    </div>
                  </div>
                  {/* <Button
                    onClick={cancelDownload}
                    fullWidth
                    style={{
                      fontSize: 13,
                      padding: 5,
                      textTransform: "capitalize",
                      textDecoration: "underline",
                    }}
                    color="primary"
                  >
                    Cancel
                  </Button> */}
                </>
              )}
              <Document
                onRenderError={() => onDocumentError()}
                onLoadError={() => onDocumentError()}
                file={summaryPDFFile}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    scale={1.5}
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    onRenderError={() => console.log("Render Error")}
                    onLoadError={() => console.log("Load Error")}
                  />
                ))}
              </Document>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

export default SummaryPdfView;
